import type { SVGProps } from 'react';

const SvgBrowsingHistory = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M15.24 13.57V19a.75.75 0 0 0 .75.75h6.18v-1.5h-5.43v-4.68Z" />
      <path d="M16.21 9.78a9.22 9.22 0 0 0-6.57 2.54 9.17 9.17 0 0 0-.42 12.87H7.7v1.5h3.35a.75.75 0 0 0 .75-.74v-3.27h-1.5v1.55a7.69 7.69 0 1 1 3.43 2.16l-.43 1.44a9 9 0 0 0 2.42.39H16a9.2 9.2 0 0 0 .22-18.4Z" />
      <path d="M29.15.13H2.85A2.72 2.72 0 0 0 .13 2.84v26.32a2.72 2.72 0 0 0 2.72 2.71h26.3a2.72 2.72 0 0 0 2.72-2.71V2.84A2.72 2.72 0 0 0 29.15.13Zm-26.3 1.5h26.3a1.22 1.22 0 0 1 1.22 1.21v3.78H1.63V2.84a1.22 1.22 0 0 1 1.22-1.21Zm26.3 28.74H2.85a1.22 1.22 0 0 1-1.22-1.21v-21h28.74v21a1.22 1.22 0 0 1-1.22 1.21Z" />
      <path d="M4.6 3.45h2.9v1.5H4.6zM9.81 3.45h2.91v1.5H9.81z" />
    </g>
  </svg>
);

export default SvgBrowsingHistory;
